export default __webpack_public_path__ + "static/media/ic-check-circle-outline.784a530e.svg";